var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li><a href="#'+
((__t=( id ))==null?'':__t)+
'"><i class="fa fa-circle '+
((__t=( type ))==null?'':__t)+
'"></i>'+
((__t=( display ))==null?'':__t)+
'</a></li>';
}
return __p;
};
